/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Method_Content_Step_02_Detail_Amateur_1_HeadingInputs */

const en_method_content_step_02_detail_amateur_1_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Amateur_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beyond the positions drill`)
};

const es_method_content_step_02_detail_amateur_1_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Amateur_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Más allá del ejercicio de posiciones`)
};

const de_method_content_step_02_detail_amateur_1_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Amateur_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Über die Positionsübung hinaus`)
};

const zh_method_content_step_02_detail_amateur_1_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Amateur_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`超越位置练习`)
};

const ar_method_content_step_02_detail_amateur_1_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Amateur_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ما وراء تمرين المواضع`)
};

const fr_method_content_step_02_detail_amateur_1_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Amateur_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Au-delà de l'exercice de positions`)
};

const vi_method_content_step_02_detail_amateur_1_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Amateur_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vượt ra ngoài bài tập vị trí`)
};

const sw_method_content_step_02_detail_amateur_1_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Amateur_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zaidi ya mazoezi ya mikao`)
};

const th_method_content_step_02_detail_amateur_1_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Amateur_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ก้าวข้ามแบบฝึกที่เน้นตำแหน่ง`)
};

const bs_method_content_step_02_detail_amateur_1_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Amateur_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dalje od vježbi položaja`)
};

const ja_method_content_step_02_detail_amateur_1_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Amateur_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`「形の練習」を超えて`)
};

const ko_method_content_step_02_detail_amateur_1_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Amateur_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`자세 연습을 넘어서`)
};

const pt_method_content_step_02_detail_amateur_1_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Amateur_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Além do treino de posições`)
};

const it_method_content_step_02_detail_amateur_1_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Amateur_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oltre l'esercizio delle posizioni`)
};

const sv_method_content_step_02_detail_amateur_1_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Amateur_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bortom positionsövningen`)
};

const nl_method_content_step_02_detail_amateur_1_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Amateur_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verder dan oefenen op posities`)
};

const da_method_content_step_02_detail_amateur_1_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Amateur_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Videre end positionsøvelser`)
};

const nb_method_content_step_02_detail_amateur_1_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Amateur_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forbi posisjonsøvelsen`)
};

const fi_method_content_step_02_detail_amateur_1_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Amateur_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Asentoharjoitteiden tuolla puolen`)
};

const pl_method_content_step_02_detail_amateur_1_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Amateur_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Więcej niż ćwiczenie pozycji`)
};

const ru_method_content_step_02_detail_amateur_1_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Amateur_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Дальше, чем упражнения на позиции`)
};

const tr_method_content_step_02_detail_amateur_1_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Amateur_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pozisyon çalışmasının ötesinde`)
};

const hi_method_content_step_02_detail_amateur_1_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Amateur_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पोज़िशन वाले अभ्यास से आगे`)
};

const id_method_content_step_02_detail_amateur_1_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Amateur_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Melampaui latihan posisi`)
};

const ms_method_content_step_02_detail_amateur_1_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Amateur_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Melangkaui latihan kedudukan`)
};

const cs_method_content_step_02_detail_amateur_1_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Amateur_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Víc než cvičení pozic`)
};

const el_method_content_step_02_detail_amateur_1_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Amateur_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Πέρα από την άσκηση των θέσεων`)
};

const he_method_content_step_02_detail_amateur_1_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Amateur_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`מעבר לתרגול תנוחות`)
};

const af_method_content_step_02_detail_amateur_1_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Amateur_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verby die posisie-oefening`)
};

const hu_method_content_step_02_detail_amateur_1_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Amateur_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Túl a pozíciógyakorlatokon`)
};

/**
* | output |
* | --- |
* | "Beyond the positions drill" |
*
* @param {Method_Content_Step_02_Detail_Amateur_1_HeadingInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const method_content_step_02_detail_amateur_1_heading = /** @type {((inputs?: Method_Content_Step_02_Detail_Amateur_1_HeadingInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Method_Content_Step_02_Detail_Amateur_1_HeadingInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_method_content_step_02_detail_amateur_1_heading(inputs)
	if (locale === "de") return de_method_content_step_02_detail_amateur_1_heading(inputs)
	if (locale === "zh") return zh_method_content_step_02_detail_amateur_1_heading(inputs)
	if (locale === "ar") return ar_method_content_step_02_detail_amateur_1_heading(inputs)
	if (locale === "fr") return fr_method_content_step_02_detail_amateur_1_heading(inputs)
	if (locale === "vi") return vi_method_content_step_02_detail_amateur_1_heading(inputs)
	if (locale === "sw") return sw_method_content_step_02_detail_amateur_1_heading(inputs)
	if (locale === "th") return th_method_content_step_02_detail_amateur_1_heading(inputs)
	if (locale === "bs") return bs_method_content_step_02_detail_amateur_1_heading(inputs)
	if (locale === "ja") return ja_method_content_step_02_detail_amateur_1_heading(inputs)
	if (locale === "ko") return ko_method_content_step_02_detail_amateur_1_heading(inputs)
	if (locale === "pt") return pt_method_content_step_02_detail_amateur_1_heading(inputs)
	if (locale === "it") return it_method_content_step_02_detail_amateur_1_heading(inputs)
	if (locale === "sv") return sv_method_content_step_02_detail_amateur_1_heading(inputs)
	if (locale === "nl") return nl_method_content_step_02_detail_amateur_1_heading(inputs)
	if (locale === "da") return da_method_content_step_02_detail_amateur_1_heading(inputs)
	if (locale === "nb") return nb_method_content_step_02_detail_amateur_1_heading(inputs)
	if (locale === "fi") return fi_method_content_step_02_detail_amateur_1_heading(inputs)
	if (locale === "pl") return pl_method_content_step_02_detail_amateur_1_heading(inputs)
	if (locale === "ru") return ru_method_content_step_02_detail_amateur_1_heading(inputs)
	if (locale === "tr") return tr_method_content_step_02_detail_amateur_1_heading(inputs)
	if (locale === "hi") return hi_method_content_step_02_detail_amateur_1_heading(inputs)
	if (locale === "id") return id_method_content_step_02_detail_amateur_1_heading(inputs)
	if (locale === "ms") return ms_method_content_step_02_detail_amateur_1_heading(inputs)
	if (locale === "cs") return cs_method_content_step_02_detail_amateur_1_heading(inputs)
	if (locale === "el") return el_method_content_step_02_detail_amateur_1_heading(inputs)
	if (locale === "he") return he_method_content_step_02_detail_amateur_1_heading(inputs)
	if (locale === "af") return af_method_content_step_02_detail_amateur_1_heading(inputs)
	if (locale === "hu") return hu_method_content_step_02_detail_amateur_1_heading(inputs)
	return en_method_content_step_02_detail_amateur_1_heading(inputs)
});